<template>
    <div class="wrap">
        <div class="one">
            <div class="oneLeft">
                <img :src="objOne.cover" :alt="objOne.offlineCourseTitle" />
            </div>
            <div class="oneRight">
                <div class="oneTitle">{{ objOne.offlineCourseTitle }}</div>
                <div class="teachOne">
                    开课时间：<span>{{ objOne.startTime }}</span
                    >培训教师：<span>{{ objOne.teacherName }}<br /></span
                    >浏览次数：<span>{{ objOne.browseNum }}</span>
                </div>
                <div class="teachTwo">
                    上课地点：<span>{{ objOne.courseAdress }}</span
                    ><br />剩余名额：<span>{{
                        objOne.registeredPersonsNum + "/" + objOne.peopleNumber
                    }}</span>
                </div> 
                <div class='Btn'  @click="signUp(objOne.id)">
                    {{ message }}
                </div>
            </div>
        </div>
        <!--课程介绍-->
        <div class="two">
            <div class="twoTitle">课程介绍</div>
            <!--公用线-->
            <div class="publicLine">
                <div class="publicChild"></div>
            </div>
            <div class="twoText">{{ objOne.courseContent }}</div>
        </div>
        <!--讲师介绍-->
        <div class="three">
            <div class="threeTitle">讲师介绍</div>
            <!--公用线-->
            <div class="publicLine">
                <div class="publicChild"></div>
            </div>
            <div class="threeContent">
                <div class="threeLeft">
                    <img
                        :src="objOne.teacherAvatar"
                        :alt="objOne.teacherName"
                    />
                </div>
                <div class="threeRight">
                    <div class="name">{{ objOne.teacherName }}</div>
                    <div class="rightText">{{ objOne.teacherIntroduce }}</div>
                </div>
            </div>
        </div>
		<div class="alert" v-show="isAlert">{{alertMessage}}</div>
    </div>
</template>

<script>
export default {
    name: "hdxq",
    data() {
        return {
			isAlert:false,
			alertMessage:'eeeeeeeeeeee',
            objOne: {
                cover: "",
                offlineCourseTitle: "",
                startTime: "",
                courseAdress: "",
                teacherName: "",
                registeredPersonsNum: "",
                peopleNumber: "",
                courseContent: "",
                teacherAvatar: "",
                teacherName: "",
                teacherIntroduce: "",
				
            },
            message: "立即报名",
            token: this.$store.state.userToken
                ? this.$store.state.userToken
                : ""
        };
    },
    methods: {
        //报名 homePage/offlineActivitiesStudy?token=eee&id
        signUp(id) {
            if (this.token) {
                this.$ajax({
                    method: "post",
                    url: "homePage/offlineActivitiesStudy",
                    data: {
                        token: this.token,
                        id: id
                    },
                    success: res => {
						this.alertMessage=res.message;
						this.isAlert=true;
						setTimeout(() => {
						   this.isAlert=false;
						}, 2000);
                       if(res.message=="报名成功"){
						   this.message='已报名';
						   this.objOne.registeredPersonsNum+=1;
					   }
                    },
                    error: res => {
                        console.log(res);
                    }
                });
            } else {
                this.$router.push({ name: "login" });
            }
        }
    },
    watch: {
        "$store.state.hasLogin": function(nval) {
            if (!nval) {
                this.$router.push({
                    name: "login"
                });
            }
        }
    },
    created() {
		if(this.$route.query.status=='已报满'){
			this.message='已报满';
		}
        this.$ajax({
            // method: "post",
            url: "homePage/getOfflineActivitiesById",
            data: {
                id: this.$route.query.id,
                token: this.$store.state.userToken
            },
            success: res => {
                // console.log(res.message)
                this.objOne = res.message;
                if (this.objOne.registrationStatus == 1) {
                    this.message = "已报名";
                }
                 if (this.objOne.registrationStatus == 4) {
                    this.message = "活动未开始";
                     $('.Btn').css('background','#ccc')
                }
                 if (this.objOne.registrationStatus == 5) {
                    this.message = "活动已截止";
                    $('.Btn').css('background','#ccc')
                }
            },
            error: res => {
                console.log(res);
            }
        });
    }
};
</script>

<style scoped="scoped">
.wrap {
    width: 1000px;
    margin: 0 auto;
    min-height: 500px;
	position: relative;
}

.one {
    overflow: hidden;
}

.oneLeft {
    width: 390px;
    height: 270px;
    float: left;
    box-sizing: border-box;
    border: 1px solid #ddd;
}
.oneLeft img {
    width: 100%;
    height: 100%;
}
.oneRight {
    width: 600px;
    height: auto;
    margin-left: 10px;
    float: left;
    box-sizing: border-box;
    /* border: 1px solid black; */
    padding: 0 10px;
}

.oneTitle {
    font-size: 25px;
    padding: 0 0 10px 0;
}

.teachOne,
.teachTwo {
    margin: 5px 0;
    font-weight: 600;
}
.teachTwo {
    margin-bottom: 55px;
}
.teachOne span,
.teachTwo span {
    margin-right: 20px;
    font-weight: 400;
}

.Btn {
    width: 150px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: #6ac0e8;
    color: white;
    margin-top: 40px;
    cursor: pointer;
}
.Btn2{
	width: 150px;
	height: 40px;
	line-height: 40px;
	text-align: center;
	background-color: #999;
	color: white;
	margin-top: 40px;
	cursor: pointer;
}
.publicLine {
    width: 100%;
    border-bottom: 2px solid gainsboro;
    position: relative;
}

.publicChild {
    width: 70px;
    border-bottom: 2px solid #6ac0e8;
    position: absolute;
    top: 0;
    left: 0;
}
.twoTitle,
.threeTitle {
    padding: 10px 0;
    font-weight: 600;
    font-size: 18px;
}

.twoText,
.threeContent {
    padding: 10px 0;
    overflow: hidden;
}
.twoText {
    min-height: 150px;
}

.threeLeft {
    width: 175px;
    height: 155px;
    float: left;
    border: 1px solid #ddd;
    box-sizing: border-box;
}
.threeLeft img {
    width: 100%;
    height: 100%;
}
.threeRight {
    width: 810px;
    height: 155px;
    float: right;
    padding: 10px;
    box-sizing: border-box;
}
.rightText {
    height: 100px;
    overflow: hidden;
}
.name {
    font-size: 18px;
    font-weight: 550;
}
.alert{
	position: absolute;
	top: 150px;
	left: 390px;

	line-height: 50px;
	font-size: 20px;
	text-align: center;
	border: 1px solid black;
	border-radius: 25px;
	border: 1px solid #ddd;
	box-shadow: 0 0 10px #000;
	background-color: #fff;
	padding: 2px 10px;
	color: #0099CC;
}
</style>



// WEBPACK FOOTER //
// src/components/xxhd/hdxq.vue